module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-L-26.bcb53a57.png";